module.exports = __webpack_public_path__ + "assets/img/28_954_big.d7ed196b.jpg";